import React from 'react';
import { useStyles } from '../../styles';
import { Box, Grid, Paper, Typography } from '@mui/material';
import EventCards from '../EventCards';
import { EventActionHeaderProps } from '../../utils/interfaces';
import { FilterCells } from '../../globalComponent/AppFilter';
import routes from '../../../../Utils/routes';
import { useHistory } from 'react-router-dom';

const EventActionHeader: React.FunctionComponent<EventActionHeaderProps> = (props) => {
  const { filterData, handleFilerRemove, eventsData, handleFilterOpen, title, filterButtonDisable } = props;
  const classes = useStyles();
  const ismobile = window.innerWidth <= 600;
    const navigate = useHistory();
  console.log(eventsData, 'eventsDataeventsDataeventsDataeventsData');

  return (
    eventsData.length > 0 && (
      <Box width={'100%'}>
        <Box component={'div'}>
          {Object.keys(filterData).length > 0 && filterButtonDisable ? (
            <div className={classes.cellsContainer}>
              <FilterCells
                cellsArray={filterData}
                handleFilerRemove={(key) => {
                  handleFilerRemove(key);
                }}
              />
            </div>
          ) : (
            <>
              {ismobile ?
                <Grid container justifyContent={'space-between'} alignItems={'center'}>
                  <Grid item>
                    <Typography className={classes.registeredEventsHeading}>
                      {title}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.registeredEventsHeading}  onClick={() => {
                      navigate.push(`${routes.allEvents}`);
                    }}>
                      View all
                    </Typography>
                  </Grid>
                </Grid>
                :
                <Typography className={classes.registeredEventsHeading}>
                  {title} ({eventsData?.length})
                </Typography>
              }
            </>
          )}
        </Box>
        <Paper className={`${classes.cardHolder}`} style={{ background:'transparent'}}>
          <Grid lg={12} container spacing={1} mt={2}>
            {eventsData &&
              (ismobile
                ? eventsData.slice(0, 2)
                : eventsData
              ).map((items: any, index: number) => {
                return (
                  <Grid item md={8} lg={4} xs={6} sm={6} key={index}>
                    <EventCards {...items} key={index} />
                  </Grid>
                );
              })}
          </Grid>
        </Paper>
      </Box>
    )
  );
};

export default EventActionHeader;
